import { ts } from '_core';

import { validate } from './helpers';
import { INTERACTION_PARAMS } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.UNIVERSE_PREVIEW_SNAPSHOT,
    form: true,
    title: 'Snapshot',
    neededFiles: ['universe_snapshot'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.UNIVERSE_PREVIEW],
    interactionParams: Object.values(INTERACTION_PARAMS),
    clearInteractionOnRegenerate: ['table_dtypes'],

    disableAdd: true,
    validate,
    helpLabel: 'fqetiq2b',
  },
] satisfies ts.types.analysis.WidgetConfig[];
